<template>
    <section class="app-main">
     
        <div class="top-bar">
            <el-input placeholder="输入商品名称查询" v-model="name" @change="search" prefix-icon="el-icon-search" style="width:260px;margin-right:20px" clearable></el-input>
            <el-button  @click="onDeal(2)" type="success" plain >通过评论</el-button>
            <el-button  @click="onDeal(3)" type="danger " plain >拒绝评论</el-button>
        </div>

        <el-card>
            <el-table ref="multipleTable" :data="tableData" height="600"  @selection-change="handleSelect">
                <el-table-column type="selection" width="60" align="center"> </el-table-column>
                <el-table-column prop="user_info.nickname" label="用户" width="150"  align="center"></el-table-column>
                <el-table-column prop="goods_info.name" label="商品名称"  min-width="160"  align="center" show-overflow-tooltip></el-table-column>
                <el-table-column  label="评论详情" min-width="300">
                    <template slot-scope="scope">
                        <div class="stars">
                            <p>商品评价：{{scope.row.s_comment}} <el-rate v-model="scope.row.s_comment" :colors="colors"  disabled class="icon-star"></el-rate></p>
                            <p>物流运输：{{scope.row.w_comment}} <el-rate v-model="scope.row.w_comment" :colors="colors"  disabled class="icon-star"></el-rate></p>
                            <p>服务评分：{{scope.row.f_comment}} <el-rate v-model="scope.row.f_comment" :colors="colors"  disabled class="icon-star"></el-rate></p>
                        </div>
                        <p>评论：{{scope.row.content}}</p>
                        <m-video v-if="scope.row.video_url" :video.sync="scope.row.video_url"  :width="70" :height="70" file-name="goodsVideo" ></m-video>
                        <div v-if="scope.row.pic_id" style="display: inline-block;">
                            <m-img v-for="(it,index) in scope.row.pic_list" :key="index" :src="it"  />
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="created_at" label="评价时间"  width="160"  align="center"></el-table-column>
                <el-table-column prop="totalMoney"  align="center" label="商品操作" fixed="right" min-width="120">
                    <template slot-scope="scope">
                        <div class="table-btns">
                            <el-button  @click="onDeal(2, scope.row)" type="success" plain size="mini">通过评论</el-button>
                            <el-button  @click="onDeal(3, scope.row)" type="danger " plain size="mini">拒绝评论</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination  background layout="prev, pager, next, jumper" :total="total" :page-size="size" @current-change="loadData" style="padding:15px 15px 15px 0"></el-pagination>
        </el-card>

        


    </section>
</template>
<script>
import { comment_list, comment_put } from '@/api/goods.js'
import MImg   from './../../../components/Image'
import MVideo from '@/components/video.vue'
import { parseTime }  from '@/untils/index.js'

export default {
    components: { MImg, MVideo },
    data() {
        return {
            name:'',
            tableData:[],
            total: 0,
            page: 1,
            size: 10,
            colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
            ids: [],
        }
    },
    methods:{

        search(){
            this.page = 1
            this.getData()
        },
        getData(){
            let params = {
                flag: 1,
                page: this.page,
            }
            if(this.name != '') {
               params.name = this.name
            }
            comment_list(params).then(res => {
                if(res){
                    this.tableData = res.data.data
                    this.tableData.forEach(item => {
                        item.created_at = parseTime(item.created_at)
                    })
                    this.total = res.data.total
                    this.size  = res.data.per_page
                } else {
                    this.tableData = []
                    this.total = 0
                }
            })
        },
        loadData(page) {
            this.page = page
            this.getData()
        },

        handleSelect(rows) {
            this.ids = []
            rows.forEach(e => {
                this.ids.push(e.id)
            });
        },
        
        onDeal(index, row) {
            let params = { flag: index }, id = ''
            if(row) {
                id = row.id
            }else {
                if(this.ids.length == 0) {
                    this.$message.error("至少要选择一条评论进行处理")
                    return false
                }
                id = this.ids.join(',')
            }
            comment_put(id, params).then(res => {
                if(res) {
                    this.getData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                }
            })
        },
       
    },
    created(){
        this.getData();
    },
    activated() {
        this.getData()
    },

        
}
</script>
<style lang="less" scoped>

section {
  .stars {
        // display: flex;
        &>p {
            display: flex;
            align-items: center;
        }
        .icon-star {
            margin-left: 10px;
            &>i {
                font-size: 20px;
                color: #FF9800;
                vertical-align: text-top;
            }
        }
    }
    .table-btns {
        .el-button{
            margin: 0 ;
            margin-bottom: 10px ;
        }
    }
    .m-img-upload {
        margin-right: 15px;
        width: 70px;
        height: 70px;
        display: inline-block !important;
    }
}
</style>
